module.exports = __webpack_public_path__ + "img/banner.3f3d9039.png";